import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
	Segment,
	TransitionablePortal
} from 'semantic-ui-react';

const Notification = ( {
	closeModal,
	id,
	message,
	open,
	...props
} ) => {
	useEffect( () => {
		const i = setInterval( () => {
			closeModal();
		}, 5000 );

		return () => {
			clearInterval( i );
		};
	}, [ closeModal ] );

	return (
		<TransitionablePortal
			id={ id }
			open={ open }
			transition={ {
				animation: 'fade',
				duration: 1000
			} }
			{ ...props }
		>
			<div>
				<Segment
					as="div"
					padded
					style={ {
						position: 'fixed',
						bottom: '4rem',
						right: '4rem',
						zIndex: 1000
					} }
					textAlign="center"
				>
					{ message }
				</Segment>
			</div>
		</TransitionablePortal>
	);
};

Notification.propTypes = {
	closeModal: PropTypes.func.isRequired,
	id: PropTypes.string.isRequired,
	message: PropTypes.node,
	open: PropTypes.bool
};

export default Notification;
